/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { BusyLabel } from "./BusyLabel";
import { Button } from "./Button";
import { Modal } from "./Modal";

/** One question before an action that cannot be taken back: what happens, then Cancel or confirm. */
export function ConfirmModal({
  title,
  body,
  confirm,
  busy,
  onClose,
  onConfirm,
}: {
  title: string;
  body: string;
  confirm: string;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}) {
  return (
    <Modal isOpen onClose={onClose} onBeforeClose={() => !busy} title={title} size="sm">
      <div className="space-y-5 px-6 py-5">
        <p className="text-sm leading-relaxed text-text-secondary">{body}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" disabled={busy} onClick={onClose}>
            Cancel
          </Button>
          <Button size="sm" disabled={busy} onClick={() => void onConfirm()}>
            <BusyLabel busy={busy} busyText="Working">
              {confirm}
            </BusyLabel>
          </Button>
        </div>
      </div>
    </Modal>
  );
}
